module.exports = __webpack_public_path__ + "img/moon-1.d1c21373.svg";